<template>
  <b-navbar-nav class="ml-auto">
    <b-nav-item-dropdown right id="userMenu" v-if="userName !== ''">
      <template v-slot:button-content>
        <em>{{ userName }} </em>
      </template>
      <b-dropdown-item href="#" @click="showUserProfile">Profile</b-dropdown-item>
      <b-dropdown-item href="#" @click="signOut">Sign Out</b-dropdown-item>
    </b-nav-item-dropdown>

    <UserProfile ref="userProfileModal"/>
  </b-navbar-nav>
</template>

<script>
  import { Auth } from 'aws-amplify'
  import UserProfile from './UserProfile'

  export default {
    components: {
      UserProfile
    },
    computed: {
      userName () {
        return (this.$store.state.apopUser) ? this.$store.state.apopUser.username : ''
      }
    },
    methods: {
      signOut (e) {
        e.preventDefault()
        Auth.signOut()
          .then(data => {
            this.$store.dispatch('completeSignOut')
            this.$router.push('/')
          })
          .catch(err =>
            console.log(err))
      },
      showUserProfile () {
        this.$refs.userProfileModal.showModal()
      }
    }
  }
</script>
